<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="space-1">
  <a [routerLink]="['../']">< Conferences</a>
  <h4>{{ conference.name }}</h4>

  <div>
    <ul class="nav nav-pills nav-fill">
      <li class="nav-item"><a class="nav-link" [routerLink]="['schedule']" [routerLinkActive]="'active'">All Events</a></li>
      <li class="nav-item"><a class="nav-link" [routerLink]="['my-schedule']" [routerLinkActive]="'active'">My Schedule</a></li>
    </ul>
    <div class="container-fluid bg-white">
      <router-outlet></router-outlet>
    </div>
  </div>
  
</div>
